export default class FrameImagePositionFull {
    constructor(frame, posterImage, dimensions) {
        this.x = dimensions.framePadding;
        this.y = dimensions.framePadding;
        this.width = posterImage.width - dimensions.framePadding;
        this.height = posterImage.height - dimensions.framePadding;
    }
}
